module.exports = __webpack_public_path__ + "static/media/map.34c513e2.svg";